export default __webpack_public_path__ + "static/media/chevron_smaller_right.32df0a6c.svg";